var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',{staticClass:"left"},[_vm._v("\n    Copyright:©2016-"+_vm._s(_vm.year)+" 大连拓中教育科技股份有限公司 \n    ")]),_c('span',{staticClass:"right"},[_vm._v(_vm._s(_vm.now))])])}
var staticRenderFns = []

export { render, staticRenderFns }